import { render, staticRenderFns } from "./ApprovalApproversTable.vue?vue&type=template&id=256d2b1f"
import script from "./ApprovalApproversTable.vue?vue&type=script&lang=js"
export * from "./ApprovalApproversTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports